if (!customElements.get("copy-coupon-add-cart-grid")) {
  class CopyCouponAddCartGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListeners();
    }

    addEventListeners() {
      const buttons = this.querySelectorAll(
        ".copy-coupon-add-cart-grid__item__right__button[data-coupon]"
      );
      buttons.forEach((button) => {
        button.addEventListener("click", (event) =>
          this.handleButtonClick(event)
        );
      });
    }

    handleButtonClick(event) {
      const button = event.currentTarget;
      const couponCode = button.getAttribute("data-coupon");
      const label = button.getAttribute("data-label");
      const success_label = button.getAttribute("data-copy-success");

      // 复制 couponCode
      navigator.clipboard.writeText(couponCode);

      // 替换span内容为 success_label
      const span = button.querySelector("span");
      span.textContent = success_label;

      // 2秒后恢复原内容和样式
      setTimeout(() => {
        span.textContent = label;
      }, 2000);
    }
  }

  customElements.define("copy-coupon-add-cart-grid", CopyCouponAddCartGrid);
}
